<template>
	<div class="infor fl">
		<AllHeader :label="lable" :ischage="ischage" :sublabel="sublabel" :subtitle="subtitle" :year="year"
			@getvalue="getvalue" />

			<el-table :data="batcheslist"
                      v-loading="loading"
				:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
				style="width: 100%; margin-top: 10px" :cell-style="{'text-align':'center'}">
				<el-table-column  label="批次" min-width="100">
				    <template slot-scope="scope">
					    {{scope.row.year}}-{{scope.row.batch}}
					</template>
				</el-table-column>
				<el-table-column prop="apply_num" label="申请数据" min-width="100"></el-table-column>
				<el-table-column prop="success_num" label="通过" min-width="100"></el-table-column>
				<el-table-column prop="fail_num" label="不通过" min-width="100"></el-table-column>
				<el-table-column   label="添加时间" min-width="150">
				    <template slot-scope="scope">
					    {{scope.row.created_at.replace(/T/g, " ").slice(0, 19)}}
					</template>
				</el-table-column>
				<el-table-column min-width="360" label="审核">
					<template slot-scope="scope">
						<el-button size="mini" type="primary"  plain @click="handleEnter(scope.row)">进入</el-button>
					</template>
				</el-table-column>
			</el-table>
	</div>
</template>

<script>
	import AllHeader from "@/components/Modal/AllHeader";

	import { AwardBatchList } from "../utils/api.js";
	export default {
		components: { AllHeader },
		data() {
			return {
                loading:true,
				step: 0,
                timeRange: '',
                exportType:1,
				ischage: false,
				lable: "工法批次",
				pageSize: 10,
				total: 0,
				awardList: [],
				sublabel: "",
				subtitle: "", //副标题
                zjId:[],
                unit:{},//参加单位信息
				user: {},
				id: '',
				year: null,
                award_id:0,
                batches:[],
                checkedlogs:[],
                created_at:'',
                batcheslist:[]
			};
		},
		mounted() {
			this.token = "Bearer " + localStorage.getItem("TOKEN");
			var zj_id = localStorage.getItem("zj_id");
			console.log("获取zjinfo",zj_id);
			if(zj_id){
				this.award_id = zj_id;
			}
			
            this.getBatches();
			
		},
        computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 250) + 'px'; //自定义高度需求
            }
        },
		methods: {
            async getBatches(){
                let res = await AwardBatchList(this.award_id);
                console.log('res.data',res)
                this.batcheslist = res;
                this.loading = false;
            },
			
			getvalue() {
				this.step = 0;
				this.ischage = false;
				this.subtitle = "";
			},
			handleEnter(info){
			    this.$router.push({
					path: '/gfprize/AwardLogreview?award_batch_id='+info.id+'&bname='+info.year+'-'+info.batch,
				});
			}
		},
	};
</script>

<style>
	.el-tabs__header {
		width: 100% !important;
	}
    .divZJ{
        text-align: left;overflow:auto;
    }
</style>
<style lang="less" scoped>
	/deep/.block-title {
		border-left: 3px solid #194abe !important;
	}

	.yellow-box {
		height: 40px;
		background: #FEF8EF;
		opacity: 1;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		align-items: center;
		justify-content: space-evenly;

		span {
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			line-height: 24px;

			&:nth-child(1) {
				color: #194ABE;
			}

			&:nth-child(2) {
				color: #0C0D0F;
			}

			&:nth-child(3) {
				color: #7C828A;
				font-size: 14px;
			}
		}
	}

	.reason {
		margin-top: 20px;
		width: 100%;
		height: 162px;
		background: #FFFFFF;
		border: 1px solid #BDC3CB;
		opacity: 1;
		border-radius: 4px;
		outline: none;
		padding: 10px;
		box-sizing: border-box;
	}

	.textarea {
		width: 382px;
		// height: 92px;
		background: #ffffff;
		border: 1px solid #bdc3cb;
		opacity: 1;
		border-radius: 4px;
	}

	.block-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin: 20px 0;

		&-item {
			width: 370px;
			background: #ffffff;
			border: 1px dashed #c8cdd5;
			padding: 24px 25px;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			margin-bottom: 21px;
			position: relative;

			&-r-t {
				position: absolute;
				top: 0;
				right: 0;
				width: 73px;
				height: 27px;
				background: #f5f9fb;
				opacity: 1;
				border-radius: 0px 0px 0px 80px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				line-height: 27px;
				color: #c6c9ce;
				padding-left: 10px;
				box-sizing: border-box;
			}

			&-box {
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;
				align-items: flex-start;

				&-t {
					width: 244px;
					color: #0c0d0f;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-align: justify;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
				}

				&-dtae {
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					line-height: 26px;
					color: #194abe;
				}

				&-startend {
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					line-height: 26px;
					color: #7c828a;
				}

				&-b {
					width: 91px;
					height: 32px;
					background: #ffffff;
					border: 1px solid #194abe;
					color: #194abe;
					opacity: 1;
					border-radius: 6px;
					text-align: center;
					line-height: 32px;
					font-size: 14px;
					cursor: pointer;
				}

				&-b-d {
					background: #ffffff !important;
					border: 1px solid #d4dbdd !important;
					color: #c8cdd5 !important;
				}

				&-b-s {
					background: #d4dbdd !important;
					border: 1px solid #d4dbdd !important;
					color: #ffffff !important;
				}
			}
		}
	}

	.margin-bottom-40 {
		margin-bottom: 40px;
	}

	.infor {
		padding-bottom: 40px;
		min-height: 800px;
		margin-bottom: 34px;
		position: relative;
	}

	.upload-demo {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}

	.uploadheader {
		height: 60px;
		width: 100%;
		display: flex;
		align-items: center;

		span {
			margin-right: 10px;
			color: #71767c;
		}
	}

	.margin-top-40 {
		margin-top: 40px;
	}

	.block-solid {
		width: 100%;
		height: 2px;
		background-color: #e51725;
		margin-top: 30px;
	}

	.shenhjrkr {
		margin: 71px 0 100px 0;

		img {
			width: 120px;
		}
	}
	.block-addr {
		display: inline-block;
		padding: 13px 32px;
		background-color: #fff7e8;
		font-size: 14px;
		margin-top: 31px;

		.span-l {
			color: #9fa5ae;
		}

		.span-r {
			color: #194abe;
		}
	}
	.pform_title {
	    font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 700;
        line-height: 20px;
        color: #0c0d0f;
        text-align: left;
	}
	.form_right {
	      width: 860px;
	      .flex {
	        display: flex;
	      }
	      .flex-direction {
	        flex-direction: column;
	      }
	      .form_1 {
	        width: 100%;
	        background: #ffffff;
	        padding: 35px 30px;
	        box-sizing: border-box;
	        margin-bottom: 30px;
	        border-radius: 6px;

			.form_dec {
				text-align: left;
				margin-top: 20px;
			}

	        .border {
	          border-top: 1px dashed #9fa5ae;
	          margin: 20px 0;
	        }
	        .bord {
	          margin-top: 11px;
	          width: 858px;
	          height: 0px;
	          border: 1px solid #194abe;
	          position: relative;
	          img {
	            width: 11px;
	            height: 6px;
	            position: absolute;
	            top: -6px;
	            left: 37px;
	          }
	        }
	        .newlybuild {
	          margin: 0 auto;
	          cursor: pointer;
	          width: 221px;
	          height: 36px;
	          border: 2px solid #194abe;
	          border-radius: 4px;
	          display: flex;
	          justify-content: center;
	          align-items: center;
	          img {
	            width: 16px;
	            height: 16px;
	            margin-right: 7px;
	          }
	          p {
	            font-size: 14px;
	            font-family: Microsoft YaHei;
	            font-weight: 400;
	            line-height: 14px;
	            color: #194abe;
	          }
	        }
	        .form_box_content {
	          width: 100%;
	          .form_title {
	            box-sizing: border-box;
	            text-align: start;
	            display: flex;
	            p {
	              font-size: 16px;
	              font-family: Microsoft YaHei;
	              font-weight: bold;
	              line-height: 20px;
	              color: #0c0d0f;
	            }
	            .delete_icon {
	              cursor: pointer;
	              margin-left: 10px;
	              width: 61px;
	              height: 25px;
	              background: #ffffff;
	              border: 1px solid #f9656f;
	              opacity: 1;
	              border-radius: 6px;
	              display: flex;
	              align-items: center;
	              justify-content: space-evenly;
	              img {
	                width: 13px;
	                height: 14px;
	              }
	              p {
	                font-size: 14px;
	                font-family: Source Han Sans CN;
	                font-weight: 400;
	                line-height: 20px;
	                color: #f9656f;
	              }
	            }
	          }
	        }
	      }
	    }

	.flex {
	    display: flex;
	    align-items: center;
	  }
	  .my_form,
	  .my_form2 {
	    width: 100%;
	    height: 100%;
	    display: flex;
	    overflow: visible;
	    align-items: stretch;
		margin-bottom: 30px;
	    .form_title {
	      width: 80px;
	      min-width: 80px;
	      height: auto;
	      display: flex;
	      justify-content: left;
	      font-size: 14px;
	      font-family: Microsoft YaHei;
	      font-weight: 400;
	      line-height: 20px;
	      box-sizing: border-box;
	      color: #808895;
	    }
	    .form_content,
	    .form_long,
	    .form_content {
			color:#323232;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			font-size: 14px;
	      position: relative;
		  padding-right: 6px;
		  text-align:left;
		  width:230px;
	    }
		.form_textarea{
			color:#323232;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			font-size: 14px;
	      position: relative;
		  padding-right: 6px;
		  text-align:left;
		}
	  }
      .a01{
          color:#000;
      }
      .a01:hover{
          color:#194ABE;
          text-decoration:underline;
      }
      .a01:visited{
          color:#000;
      }
      .span02{
          font-weight: 400;
          color: #37C8AA;
          margin-left: 5px;
      }
      .span03{
          color: #B0B6C1;
          font-weight: 400;
      }
	  .spanText{
		  margin-top:25px;
		  font-size: 16px;
		  font-family: PingFang SC-Semibold, PingFang SC;
		  font-weight: 600;
		  color: #194ABE;
		  line-height: 0px;
		  -webkit-background-clip: text;
	  }
      .radio01{
          background:#F5F6F7;
          margin-bottom:15px;
          border: none !important;
          width:100px;
          margin-left: 10px;
          margin-right: 10px;
          white-space: nowrap;
          display: inline-block;
          overflow: hidden;
      }
      .pos-page {
      	position: absolute;
      	bottom: 0px !important;
      	width: 100%;
      }

      .infor {
          width: 1050px !important;
      }
      .w-1200 {
          width: 1500px  !important;
          margin: 0 auto;
      }
</style>
